<template>
<div class="box">
    <div class="top">
        Apex一键作图
    </div>
    <div class="content">
      <div class="content_item_list">
          <div class="content_item input_item " :class="item.type" v-for="item in List" :key="item.title" :data-type="item.type" :data-multiple="item.multiple">
          <div class="item_title" :data-title="item.title">
            {{item.desc}}
          </div>
          <div class="item_pifu_list" v-if="item.type=='selectImg'">
            <div class="item_pifu" @click="selectImg(option,item.multiple,item.options)" v-for="option in item.options" :key="option.title"  :data-type="option.title" data-checked="false">
              <div class="pifu">
                <div class="pifu_img_box" :class="option.ming_num>=0?'active':''">
                  <img class="pifu_img" :src="baseUrl + option.icon_url" >
                </div>
                <div class="pifu_title">{{option.name}}</div>
                <img class="checked" src="img/checked.png"  v-if="option.ming_num>=0">
                <img class="checked" src="img/not_checked.png"  v-if="option.ming_num<0">
              </div>

            </div>
          </div>
          <div class="item_select" v-else-if="item.type=='select'">
            <div class="option" @click="select(option,item.multiple,item.options)"  v-for="option in item.options" :key="option.title"  :data-multiple="item.multiple">
              <img class="checked" src="img/checked.png"  v-if="option.ming_num>=0">
              <img class="checked" src="img/not_checked.png"  v-if="option.ming_num<0">
              {{option.name}}
            </div>
          </div>
          <input class="item_input" v-else-if="item.type=='input'" v-for="option in item.options"  v-model="option.content" @change="info[option.id]=option.title+':'+option.content" :key="option.title" type="text" :placeholder="option.placeholder" :maxlength="option.max_len">
          <input class="item_input" v-else-if="item.type=='number'" v-for="option in item.options" v-model="option.content"  @change="info[option.id]=option.title+':'+option.content" :key="option.title" type="number" :placeholder="option.placeholder" :max="option.max"  :min="option.min">
          <textarea class="item_textarea" v-else-if="item.type=='textarea'"  v-for="option in item.options"  v-model="option.content" @change="info[option.id]=option.title+':'+option.content" :key="option.title" :placeholder="option.placeholder" :maxlength="option.max_len"></textarea>
        </div>
        </div>
        <div class="btn" @click="showModal">
            <div class="btn_text">一键作图生成</div>
        </div>
    </div>
    <div class="canvas_box" v-if="isShowModal">
        <div class="canvas_box_border">
            <div class="canvas" :style="{background:color}">
                <div class="canvas_center">
                  <div class="content_item_list">
                    <div class="content_item input_item" v-for="item in List" :key="item.title" :data-type="item.type" >
                      <div class="canvas_item_title" :data-title="item.title" >
                        {{item.desc}}
                      </div>
                      <div class="canvas_item_pifu_list" v-if="item.type=='selectImg'">
                        <div  v-for="option in item.options" :key="option.title"  :data-type="option.title" data-checked="false">
                          <div class="canvas_pifu_img" v-if="option.ming_num>=0">
                          <div class="canvas_pifu"  >
                            <div class="canvas_pifu_img_box">
                              <img class="pifu_img" :src="baseUrl + option.icon_url" >
                            </div>
                            <div class="pifu_title">{{option.name}}</div>
                          </div>
                          </div>
                        </div>
                      </div>
                      <div class="item_select" v-else-if="item.type=='select'">
                        <div class="option"  v-for="option in item.options" :key="option.title"  data-checked="false">
                          <span v-if="option.ming_num>0">{{option.name}}</span>
                        </div>
                      </div>
                      <div class="item_select" v-else-if="item.type=='input'">
                        <div class="option"  v-for="option in item.options" :key="option.title"  data-checked="false">
                          {{option.content}}
                        </div>
                      </div>
                      <div class="item_select" v-else-if="item.type=='number'">
                        <div class="option" v-for="option in item.options" :key="option.title"  data-checked="false">
                          {{option.content}}
                        </div>
                      </div>
                      <div class="item_select" v-else-if="item.type=='textarea'">
                        <div class="option" v-for="option in item.options" :key="option.title"  data-checked="false">
                          {{option.content}}
                        </div>
                      </div>
                        </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="canvas_btn_box">
            <div class="btn" @click="createImg">
                <div class="btn_text">下载原图</div>
            </div>
            <div class="btn" @click="cancelModal">
                <div class="btn_text">取消</div>
            </div>
            <div class="btn copy" @click="copy_desc">
                <div class="btn_text" >复制文字</div>
            </div>
          <div class="btn "><div class="btn_text" >选择背景色<colorPicker v-model="color" style="font-size: 50px"></colorPicker></div></div>
        </div>
    </div>
    
    <div class="mask" v-if="isShowModal"></div>
    </div>
</template>
<script>

import {copy, Falert} from "@/unitl/common";
    import html2canvas from "html2canvas";
import {GetApexData} from "@/server";
    export default {
        name: "Apex",
        data() {
            return {
                showCreateLoading: false,
                selectList: [],
                List: [],
                keywords:'',
                keywords_arr:[],
                searched:[],
                info:[],
                unSearched:{},
                unSearchedCount:0,
                searchCount:0,
                refresh:true,
                isShowModal:false,
                isDownloading:true,
                color:'',
                baseUrl :'',
                infoText:''
            };
        },
        computed:{
            bodyColor(){
                if(this.color){
                    return {background:this.color};
                }
                return{};
            },
            backgroundStyle(){
                var backgroundImg='';
                var backgroundRepeat='';
                var bg=require('../assets/bg4.png');
            
                if(this.showShuiyin){
                    backgroundImg=`url(${bg})`;
                    backgroundRepeat='repeat-y';
                }
            
                let style={
                    backgroundImage:backgroundImg,
                    backgroundRepeat:backgroundRepeat,
                    backgroundSize:'100%'
                }
                return style;
            }
        },
    
    
        components: {
        },
        watch: {
            pageIndex(val) {
                this.loadBackgounds(val);
            },
            refresh(v){
                if(!v){
                    setTimeout(()=>{
                        this.refresh=true;
                    },100)
                }
            }
        },
        methods: {
            showModal() {
                this.isShowModal=true;
            },
            cancelModal() {
                this.isShowModal=false;
            },
            copy_desc() {
              console.log(this.info);
              this.infoText=this.info.filter(function (s) {
                    return s && s.trim()}).join(' ');
              if(navigator.clipboard){
                navigator.clipboard
                    .writeText(this.infoText)
                    .then(() => {
                      Falert("复制成功")
                    })
                    .catch(() => {
                      Falert("复制失败")
                    })
              }else{
                    copy(this.infoText)
                    Falert("复制成功")
              }
            },
            allSelect(){
                var list = document.querySelectorAll(".show-search");
                for(var i=0;i<list.length;i++){
                    list[i].click();
                }
            },
            showItem(name){
                var unSearched=this.unSearched;
                delete unSearched[name];
                this.unSearchedCount-=1;
                this.unSearched=unSearched;
            },

          selectImg(option,multiple,options){
            if(!multiple){
              for(var i=0;i<options.length;i++){
                options[i].ming_num=-1;
                this.info[options[i].id]='';
              }
            }
            if(option.ming_num>0){
              option.ming_num=-1;
              this.info[option.id]='';

            }else{
              option.ming_num=1
              this.info[option.id]=option.title;
            }
            },
          select(option,multiple,options){
              if(!multiple){
                  for(var i=0;i<options.length;i++){
                    options[i].ming_num=-1;
                    this.info[options[i].id]='';
                  }
              }
            if(option.ming_num>0){
                option.ming_num=-1;
                this.info[option.id]='';

            }else{
                option.ming_num=1
                this.info[option.id]=option.title;
            }

          },
            cancelSelect(){
                for(var i=0;i<this.List.length;i++){
                    for(var j=0;j<this.List[i].length;j++){
                        this.List[i].options[j].ming_num=-1;
                    }
                }
            },
            
            createImg() {
                this.showCreateLoading = true;
                let dom = document.querySelector('.canvas')
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                html2canvas(dom, {
                    imageTimeout: 1000000,
                    useCORS: true,
                    scrollY: -scrollTop,
                    width: dom.clientWidth,
                    height: dom.clientHeight,
                }).then(canvas => {
                    // 通过a标签下载到本地
                    let link = document.createElement("a");
                    link.href = canvas.toDataURL("image/jpeg");
                    link.setAttribute("download", Date.now() + ".jpg");
                    link.style.display = "none";
                    document.body.appendChild(link);
                    link.click();
                    this.showCreateLoading = false;
                });
            
            },
        
            init(){
              GetApexData().then(ret=>{
                console.log(ret)
                this.List=ret;
              })
            }
        },
        mounted() {
        
            this.init();
        
        }
    };


</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.active{
  -moz-box-shadow:0px 0px 20px #003ADB;
  -webkit-box-shadow:0px 0px 20px #003ADB;
  box-shadow:0px 0px 20px #003ADB;
}
.box {
  position: relative;
  display: flex;
  flex-direction: column;
}

.top {
  padding-top: 20px;
  background: #15212e;
  color:#fff;
  font-size: 28px;
  display: flex;
  align-items: center;
  padding-left: 340px;
}


.content {
  background: #111c29;
  background-size: 100% auto;
  height: auto;
  padding-bottom: 154px;
}

.content_item {
  width: 1200px;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
  flex-direction: column;
}

.input_item{
  flex-direction: initial;
}

.input_item .item_title{
  width: 350px;
  display: block;
  text-align: left;
  padding-top:15px;
}
.input_item .item_input{
  width: 1200px;
  display: block;
}
.item_title {
  font-size: 24px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 31px;
  color: #7a91ff;
}
.canvas_item_title {
  width: 190px;
  font-size: 24px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffd508;
}
.item_pifu_list {
  display: flex;
  width: 1200px;
  flex-wrap: wrap;
  justify-content: center;
  border-radius: 10px;
  padding:20px 0;
}

.item_pifu {
  display: flex;
  flex-direction: column;
  margin-right: 6px;
  padding-bottom: 10px;
}
.ming_num{
  position: absolute;
  right: 0;
  top: 0;
  color: #fff;
  background: #f00;
  border-radius: 5px;
  padding: 0 5px;
}
.pifu {
  cursor: pointer;
  position: relative;
}

.pifu_img_box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pifu_img {
  width: 110px;
  height: 110px;
}
.canvas_item_pifu_list {
  display: flex;
  width: 1000px;
  flex-wrap: wrap;
  border-radius: 10px;
  padding:20px 0;
}

.canvas_pifu_img_box {
  width: 130px;
  position: relative;
}
.canvas_pifu_img {
  width: 130px;
  padding: 5px;
}
.pifu_title {
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color:#fff;
}
.item_select {
  display: flex;
  align-items: center;
  justify-content: left;
  flex-wrap: wrap;
  width: 1200px;
}

.option {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #FFFFFF;
  margin: 5px;
  width: 200px;
  cursor: pointer;
}

.checked {
  margin: 0;
  width: 40px;
  margin-right: 10px;
}

.selectImg{
  flex-direction: column !important;
  align-items: center;
  justify-content: center;

}
.selectImg .item_title{
    width: 1200px;
    text-align: center;
    align-items: center;
    justify-content: center;
}
.item_input {
  width: 442px;
  height: 48px;
  background: #FFFFFF;
  border-radius: 48px;
  padding: 0 20px;
  font-size: 24px;
  font-weight: 500;
  color: #565656;
  margin: 0 auto;
  border: 2px solid #6856fd;
  outline: none;
  margin-top: 10px;
}

.item_input::-webkit-input-placeholder {
  color: #999999;
}

.item_textarea {
  width: 1200px;
  height: 300px;
  background: #FFFFFF;
  border-radius: 12px 12px 12px 12px;
  opacity: 1;
  border: 2px solid #6856fd;
  font-size: 24px;
  font-weight: 500;
  color: #565656;
  padding: 15px 18px;
  margin: 0 auto;
  outline: none;
  resize: none;
  scrollbar-width: none;
}

textarea::-webkit-scrollbar {
  display: none;
}

.btn {
  width: 448px;
  height: 86px;
  background:#41a5f1;
  border-radius: 14px 14px 14px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 62px auto 0;
  cursor: pointer;
}

.btn_text {
  font-size: 36px;
  font-weight: bold;
  line-height: 50px;
  color:#fff
}

.canvas_box {
  width: 1200px;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.canvas_box .item_pifu_list{
  border: none;
}
.canvas {
  background: rgb(87, 108, 132);
}

.canvas_top {
  height: 140px;
  display: flex;
  justify-content: left;
}

.canvas_center {
  background-size: 100% auto;
  padding-top: 25px;
}

.left_item_title {
  font-size: 30px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: left;
  margin-bottom: 31px;
  color: #284587;
}

.canvas_pifu {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  color: #fff;
  position: relative;
}

.canvas_item_img {
  padding-left: 60px;
  padding-right: 60px
}

.canvas_item_text {
  margin-bottom: 20px;
  display: flex;
  padding-left: 50px;
  padding-right: 50px
}

.canvas_btn_box {
  display: flex;
  background: #000;
  justify-content: center;
}

.canvas_btn_box .btn {
  margin: 10px 27px 10px 27px;
}

.mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  display: none;
}

.item_text {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
}
</style>